import { render, staticRenderFns } from "./ProductManage.vue?vue&type=template&id=191f994f&scoped=true"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"
import style0 from "./ProductManage.vue?vue&type=style&index=0&id=191f994f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191f994f",
  null
  
)

export default component.exports